import { Header } from "@/pages/MainPage/ui/Header/Header";
import { FirstPage } from "@/pages/MainPage/ui/First/First";
import styles from "./MainPage.module.scss";
import { About } from "@/pages/MainPage/ui/About/About";
import { ExperiencePage } from "@/pages/MainPage/ui/Experience/Experience";
import { Expert } from "@/pages/MainPage/ui/Expert";
import { MyProducts } from "@/pages/MainPage/ui/MyProducts";
import { Footer } from "@/pages/MainPage/ui/Footer";
import { MainLayout } from "@/shared/layouts/MainLayout";

export const MainPage = () => {
    return (
        <MainLayout
            header={<Header />}
            footer={<Footer />}
            className={styles.main}
        >
            <FirstPage />
            <About />
            <ExperiencePage />
            <Expert />
            <MyProducts />
        </MainLayout>
    );
};
